<template>
    <div>
        <div v-if="!isLoading && vfairuserLoaded" class="vfairs-list">
            <div v-for="vfair in data" :key="vfair.id">
                <Paper tall>
                    <router-link
                        :to="$URLS.vfair.concat('/', vfair.id)"
                        style="text-decoration:none;position:relative;"
                    >
                        <div class="h-200 clickable px-3 py-3 vfair-item">
                            <div class="mt-1 d-flex flex-column flex-grow">
                                <div class="flex-row-reverse">
                                    <span class="mb-2 gray-color">
                                        <h6 class="mb-1">
                                            {{ vfair.title }}
                                        </h6>
                                    </span>
                                    <h6 class="caption text-small mb-1 gray-color">
                                        <DateRange
                                            :start="vfair.start"
                                            :end="vfair.end"
                                        ></DateRange>
                                    </h6>
                                </div>
                            </div>

                            <div class="mt-1 d-flex flex-column justify-content-end">
                                <div class="d-flex flex-row justify-content-end">
                                    <OngoingBadge
                                        :start="vfair.start"
                                        :end="vfair.end"
                                    ></OngoingBadge>
                                    <span v-if="getInterested(vfair.id)"
                                        ><BaseIcon class="check" name="check"
                                    /></span>
                                </div>
                            </div>
                        </div>
                    </router-link>
                </Paper>
            </div>
        </div>
        <div v-else>
            <VFairListSkeleton />
        </div>
    </div>
</template>

<script>
// Utils
import VFairListSkeleton from '../../../../components/skeletons/VFairListSkeleton';
import DateRange from '../../components/DateRange';
import OngoingBadge from '../../components/OngoingBadge';

export default {
    name: 'VFairList',
    components: { VFairListSkeleton, DateRange, OngoingBadge },
    props: {
        data: {
            type: Array,
            default: () => [],
        },
        isLoading: Boolean,
    },
    data() {
        return {};
    },
    computed: {
        vfairuser() {
            return this.$interfaces.vfairuser.user.me.get({
                reactive: true,
            });
        },
    },
    methods: {
        vfairuserData() {
            return this.vfairuser.data;
        },
        vfairuserLoaded() {
            return this.vfairuser.loaded;
        },
        getInterested(id) {
            let data = this.vfairuserData().filter(data => data.vfairId === id);
            if (data && data[0]) {
                return data[0].interested;
            }
            return false;
        },
    },
};
</script>

<style scoped>
.vfairs-list {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 20px;
}
.vfair-item {
    display: grid;
    grid-template-rows: repeat(auto);
    grid-template-columns: 1fr;
    grid-auto-flow: row;
    grid-column-gap: 1rem;
    grid-row-gap: 0.2rem;
    min-height: 160px;
}
@media only screen and (max-width: 600px) {
    .vfairs-list {
        grid-template-columns: 1fr;
        grid-auto-flow: row;
        overflow: scroll;
    }
}

.check {
    font-size: 18px;
    color: var(--primary);
}
</style>
